import BancoDoAuto25BlackBG from '@/components/organisms/BancoDoAuto25BlackBG';
import BancoDoAuto25Stack from '@/components/organisms/BancoDoAuto25Stack';
import BancoDoAuto25Video from '@/components/organisms/BancoDoAuto25Video';
import Styles from './FinanciamentoDeMotos25.css';
import Head from 'next/head';
import React from 'react';
import RedButton from '@/components/atoms/RedButton';
import BancoAutoMoto from '@/components/molecules/BancoAutoMoto';
import BancoAutoFinancieMoto from '@/components/molecules/BancoAutoFinancieMoto';
import BancoAutoMotoDesktop from '@/components/molecules/BancoAutoMotoDesktop';
import BancoDoAutoPerguntas from '@/components/organisms/BancoDoAutoPerguntas';
import FinanciamentoDeMotos25Blog from '@/components/organisms/FinanciamentoDeMotos25Blog';
import { isMobile } from '../../../utils/browser';
import DisclaimerF1 from '@/components/molecules/DisclaimerF1';

function FinanciamentoDeMotos25() {
  const faqTitle = 'Saiba mais sobre financiamento de motos';
  const imgpng = 'assets/banco-do-auto25/img-perguntas-moto.png';
  const imgwebp = 'assets/banco-do-auto25/img-perguntas-moto.webp';
  const imgalt = 'Homem branco verificando o motor de sua moto financiada pelo Santander';
  const faqs = [
    {
      pergunta: 'Quem pode financiar uma moto?',
      resposta:
        'Qualquer cliente que precise de um veículo, tanto para passeio, quanto para trabalho. Também oferecemos crédito para Pessoas com Deficiência (PCD) que desejam comprar um veículo adaptado às suas necessidades.',
    },
    {
      pergunta: 'Quais documentações necessárias para realizar um financiamento?',
      resposta: 'Precisamos de seus documentos de identificação: RG, CPF e CNH.',
    },
    {
      pergunta: 'É possível financiar 100% do valor de um veículo?',
      resposta:
        'Sim, em cada simulação é feita uma análise para definir as condições de financiamento liberadas para cada cliente.',
    },
    {
      pergunta:
        'Quais dados são necessários para realizar uma simulação em uma loja ou concessionária?',
      resposta:
        'Basta apenas o CPF/CNPJ do cliente para conseguir realizar uma simulação de financiamento.',
    },
    {
      pergunta: 'É necessário ser correntista Santander para realizar financiamento com o Banco?',
      resposta:
        'Não há necessidade do cliente já ser correntista Santander, porém ele tem a opção de se tornar correntista durante a jornada de financiamento e aproveitar diversos benefícios.',
    },
    {
      pergunta: 'Qual é a taxa de juros do financiamento?',
      resposta:
        'A taxa de juros vai depender de cliente para cliente. Isso porque é realizada uma análise de crédito no momento do financiamento.',
    },
  ];

  return (
    <>
      <Head>
        <title>Financiamentos de Motos | Santander Financiamentos</title>
        <meta
          name="Description"
          content="Simular um financiamento de moto nova ou usada ficou muito mais fácil com a Santander financiamentos! Financie sua moto em até 48x!"
        />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/financiamento-de-motos.html"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:title" content="Financiamento de motos | Santander Financiamentos" />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/financiamento-de-motos.html"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />;
        <meta
          property="og:description"
          content="Simular um financiamento de moto nova ou usada ficou muito mais fácil com a Santander financiamentos! Financie sua moto em até 48x!"
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/banco-do-auto25/banners/bg-banner-motos.webp"
        />
        <meta
          property="og:image:alt"
          content="Homem branco encostado em moto vermelha financiada pelo Santander"
        />
        <meta property="og:image:type" content="image/webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />
        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Financiamento de motos | Santander Financiamentos" />
        <meta
          name="twitter:description"
          content="Simular um financiamento de moto nova ou usada ficou muito mais fácil com a Santander financiamentos! Financie sua moto em até 48x!"
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/financiamento-de-motos.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/banco-do-auto25/banners/bg-banner-motos.webp"
        />
        <meta
          property="twitter:image:alt"
          content="Homem branco encostado em moto vermelha financiada pelo Santander"
        />
        <meta property="twitter:image:type" content="image/webp" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
      </Head>
      <DisclaimerF1 />
      <BancoDoAuto25BlackBG id="financiamento-moto">
        <div className="container-imagem mobile">
          {/* <div className="linear-gradiente" /> */}
          <picture>
            <source type="image/webp" srcSet="assets/banco-do-auto25/financiamento-moto.webp" />
            <source type="image/png" srcSet="assets/banco-do-auto25/financiamento-moto.png" />
            <img
              src="assets/banco-do-auto25/financiamento-moto.png"
              alt="Homem branco de jaqueta preta colocando capacete em cima de moto financiada pelo Santander"
            />
          </picture>
        </div>
        <BancoDoAuto25Stack>
          <div className="container-imagem desktop">
            {/* <div className="linear-gradiente" /> */}
            <picture>
              <source type="image/webp" srcSet="assets/banco-do-auto25/financiamento-moto.webp" />
              <source type="image/png" srcSet="assets/banco-do-auto25/financiamento-moto.png" />
              <img
                src="assets/banco-do-auto25/financiamento-moto.png"
                alt="Homem branco de jaqueta preta colocando capacete em cima de moto financiada pelo Santander"
              />
            </picture>
          </div>
          <div className="c2c-stack-content-veiculo">
            <img src="assets/banco-do-auto25/ic_vehicle_moto.svg" alt="veiculo" />
            <h1 className="c2c-stack-title">Financiamento de moto</h1>
            <p className="c2c-stack-subtitle">
              O financiamento de moto usada e nova no Santander pode tornar realidade o seu sonho de
              pilotar com economia e facilidade!
              <br />
              <br />
              Além de contar com crédito para conquistar esse sonho, aqui você também pode contratar
              um seguro e proteger seu bem de possíveis imprevistos.
            </p>
            <RedButton
              href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&amp;int_medium=financiamento-de-moto:2a-dobra&amp;int_campaign=simular"
              target="_blank"
              className="btn-simule"
            >
              Simular
            </RedButton>
          </div>
        </BancoDoAuto25Stack>
      </BancoDoAuto25BlackBG>
      {isMobile() && <BancoAutoMoto />}
      <BancoAutoFinancieMoto />
      {!isMobile() && <BancoAutoMotoDesktop />}
      <BancoDoAutoPerguntas
        imgpng={imgpng}
        imgwebp={imgwebp}
        imgalt={imgalt}
        faqtitle={faqTitle}
        faqs={faqs}
      />
      <FinanciamentoDeMotos25Blog />
      <style jsx>{Styles}</style>
    </>
  );
}

export default FinanciamentoDeMotos25;
